/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'ExternalUserAccessToken' store object.
 * @namespace ExternalUserAccessTokenSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UAExternalUserAccessToken';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ExternalUserAccessTokenSelectors
   */
  static fetchSdGetAccessToken = state =>
    state[selectors.moduleIdentifier].fetchSdGetAccessToken.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ExternalUserAccessTokenSelectors
   */
  static isFetchingFetchSdGetAccessToken = state =>
    state[selectors.moduleIdentifier].isFetchingFetchSdGetAccessToken.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ExternalUserAccessTokenSelectors
   */
  static fetchSdGetAccessTokenError = state =>
    state[selectors.moduleIdentifier].fetchSdGetAccessTokenError.payload;
}
